import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenis: Lenis | null = null;
let tick: ((time: number) => void) | null = null;

export function getLenis() {
  return lenis;
}

/** Jump instantly (no easing) — used for route changes. */
export function jumpTo(y: number | HTMLElement) {
  if (lenis) lenis.scrollTo(y, { immediate: true, force: true });
  else if (typeof y === 'number') window.scrollTo(0, y);
  else y.scrollIntoView({ block: 'start' });
}

export function startSmoothScroll() {
  if (lenis) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  if (reduced || !finePointer) return; // touch devices keep native scrolling

  lenis = new Lenis({
    lerp: 0.12, // restrained, not floaty
    wheelMultiplier: 1,
    smoothWheel: true,
    syncTouch: false,
    prevent: (node: HTMLElement) => !!node.closest?.('[data-lenis-prevent]'),
  });
  // One shared clock: Lenis drives ScrollTrigger every frame.
  lenis.on('scroll', ScrollTrigger.update);
  tick = (time: number) => lenis?.raf(time * 1000);
  gsap.ticker.add(tick);
  gsap.ticker.lagSmoothing(0);
}

export function stopSmoothScroll() {
  if (tick) gsap.ticker.remove(tick);
  tick = null;
  lenis?.destroy();
  lenis = null;
}